import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getServicesManager } from '../../../services'
import { ChatBot } from '../../../interfaces/bot-config'
import { PayloadAction } from '@reduxjs/toolkit'

// Async thunks
export const fetchChatBots = createAsyncThunk(
  'chatBots/fetchChatBots',
  async () => {
    const servicesManager = getServicesManager()
    const bots = await servicesManager.getChatBots()
    return bots || []
  }
)

// State interface
interface ChatBotsState {
  bots: ChatBot[]
  isLoading: boolean
  error: string | null
}

const initialState: ChatBotsState = {
  bots: [],
  isLoading: false,
  error: null,
}

// Slice
const chatBotsSlice = createSlice({
  name: 'chatBots',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clearBots: (state) => {
      state.bots = []
      state.error = null
    },
    addBot: (state, action: PayloadAction<ChatBot>) => {
      state.bots.push(action.payload)
    },
    updateBot: (state, action: PayloadAction<ChatBot>) => {
      const index = state.bots.findIndex(bot => bot.agent_id === action.payload.agent_id)
      if (index !== -1) {
        state.bots[index] = action.payload
      }
    },
    deleteBot: (state, action: PayloadAction<string>) => {
      state.bots = state.bots.filter(bot => bot.agent_id !== action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatBots.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchChatBots.fulfilled, (state, action) => {
        state.isLoading = false
        state.bots = action.payload
      })
      .addCase(fetchChatBots.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message || 'Failed to fetch chat bots'
      })
  },
})

export const { clearError, clearBots, addBot, updateBot, deleteBot } = chatBotsSlice.actions
export default chatBotsSlice.reducer 